const FACTOR_FOR_DUBBING = 3
const FACTOR_FOR_LIP_SYNCING_FOX = 15
const FACTOR_FOR_LIP_SYNCING_TIGER = 30
const FACTOR_FOR_LIP_SYNCING_DRAGON = 90

export default function getSetupCosts(
  projectVersionDuration: number,
  hasNewTranscription: boolean,
  hasTranscriptSrtWithoutGuideline: boolean,
  numberOfNewTranslationSubtitles: number,
  numberOfExistingSubscriptionSubtitles: number,
  willDub: boolean,
  willSyncLips: boolean,
  lipSyncOption: string | null,
  subscriptionHasCreditLikeCharging: boolean,
  numberOfNewTranslationSubtitlesWithSrtWithoutGuideline: number
): number {
  const numberOfNewSubtitles = hasNewTranscription ? numberOfNewTranslationSubtitles + 1 : numberOfNewTranslationSubtitles
  const subtitlesCostCredits = numberOfNewSubtitles * projectVersionDuration - (hasTranscriptSrtWithoutGuideline ? projectVersionDuration : 0) - numberOfNewTranslationSubtitlesWithSrtWithoutGuideline * projectVersionDuration
  const voiceCost = numberOfNewTranslationSubtitles * projectVersionDuration * FACTOR_FOR_DUBBING
  const isFox = lipSyncOption === 'Fox model'
  const isTiger = lipSyncOption === 'Tiger model'
  const factorForLipSync = isFox ? FACTOR_FOR_LIP_SYNCING_FOX : isTiger ? FACTOR_FOR_LIP_SYNCING_TIGER : FACTOR_FOR_LIP_SYNCING_DRAGON
  const lipSyncCost = willSyncLips ? numberOfNewTranslationSubtitles * projectVersionDuration * factorForLipSync : 0
  const dubbingCost = willDub ? voiceCost + lipSyncCost : 0
  const totalCostWithCreditLikeCharging = subtitlesCostCredits + dubbingCost
  const hasNoSubscriptionSubtitles = numberOfExistingSubscriptionSubtitles === 0
  const allNewTranslationSubtitlesHaveSrtWithoutGuideline = numberOfNewTranslationSubtitlesWithSrtWithoutGuideline === numberOfNewTranslationSubtitles
  const subtitlesCostWithoutCreditLikeCharging = numberOfNewSubtitles > 0 && hasNoSubscriptionSubtitles && !hasTranscriptSrtWithoutGuideline && !allNewTranslationSubtitlesHaveSrtWithoutGuideline ? projectVersionDuration : 0
  const totalCostWithoutCreditLikeCharging = subtitlesCostWithoutCreditLikeCharging // no cost for dubbing without credit-like charging in which case the totalCostCredit is used
  const totalCost = subscriptionHasCreditLikeCharging ? totalCostWithCreditLikeCharging : totalCostWithoutCreditLikeCharging

  return totalCost
}
